import { render } from "./HowitWorks.vue?vue&type=template&id=2c24b8e6"
import script from "./HowitWorks.vue?vue&type=script&lang=js"
export * from "./HowitWorks.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__